module.exports = __webpack_public_path__ + "static/Group 6712-a7f3fc404a8e92718cda883182f79304.png";